import { UiAlertsStore } from "../../Common/_stores/UiAlertsStore";

export const uiAlertActions = {
    success: UiAlertsStore.actionSuccessAlert,
    error: UiAlertsStore.actionErrorAlert,
    clear: UiAlertsStore.actionClearAlert,
};